export default __webpack_public_path__ + "static/media/illu_phone.2aa4dcad.png";